import {privateApi} from 'utils/api'

export const getBranchActivity = async (payload: any) =>
    await privateApi.post('/cps/v1/dashboard/ff-branch-activity', payload)

export const getMyAllotment = async (payload: any) =>
    await privateApi.post('cps/v1/allotment/allotment-status-ffdashboard', payload)

export const getMyCarriers = async (payload: any) =>
    await privateApi.post('/cps/v1/dashboard/ff-mycarriers-status', payload)

export const getMyShipments = async (payload: any) =>
    await privateApi.post('/cps/v1/shipment/airwaybills-ffdashboard', payload)
